import { buttonStyles } from '@festina-life/ui/actions'
import { paperStyles, zIndexStyles } from '@festina-life/ui/libs'
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@festina-life/ui/structure'
import cx from 'classnames'
import { Fragment, type PropsWithChildren, type ReactNode } from 'react'

type Props = {
  trigger: ReactNode
  panelClassName?: string
}

export const PreferencesMenu = ({
  trigger,
  panelClassName,
  children,
}: PropsWithChildren<Props>) => (
  <Popover className="relative">
    <PopoverButton
      className={cx(
        buttonStyles({
          variant: 'text',
          disabled: false,
          isDanger: false,
          isFullWidth: false,
        }),
        'py-0!',
      )}
    >
      {trigger}
    </PopoverButton>
    <Transition
      as={Fragment}
      enter="transition ease-out duration-200"
      enterFrom="opacity-0 translate-y-1"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-150"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-1"
    >
      <PopoverPanel
        isShowingBackdrop
        className={cx(
          'absolute rounded-lg p-2 shadow-lg',
          paperStyles({ isFaded: true, borders: ['all'] }),
          zIndexStyles('popovers'),
          panelClassName,
        )}
      >
        {children}
      </PopoverPanel>
    </Transition>
  </Popover>
)
